import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { RelatedItemCollection } from '../../@types/item';

import OverflowGrid from '../../components/overflow-grid';
import ProductCard from '../../components/product-card-v2';
import { Column, Columns } from '../../styled-components/components/Columns';
import { Container } from '../../styled-components/components/Container';
import { H3 } from '../../styled-components/components/Heading';
import { Link } from '../../styled-components/components/Link';
import { PageSection } from '../../styled-components/components/Page';
import { VStack } from '../../styled-components/components/VStack';

interface ItemCollectionProps {
  collection: RelatedItemCollection;
}

const ItemCollection = ({ collection }: ItemCollectionProps) => {
  const { t } = useTranslation('error');
  const [visibleKey, setVisibleKey] = useState(0);
  const overflowGridRef = useRef<HTMLDivElement | null>(null);

  if (!collection.documents.length) {
    return null;
  }

  return (
    <PageSection>
      <Container>
        <VStack $spacing={2}>
          <Columns $spacing={2} $valign="center">
            <Column $grow>
              <H3 as="h2" $margin="none">
                {collection.title}
              </H3>
            </Column>
            <Column $noShrink>
              <Link
                href={collection.moreLink}
                title={t('seeAllCollection', { ns: 'error', collection: collection.title })}
              >
                {t('seeAllSimilarCars', { ns: 'error' })}
              </Link>
            </Column>
          </Columns>
          <OverflowGrid
            visibleItems={3}
            modifiers="offset-button-3:2"
            forwardedRef={overflowGridRef}
            onNavigate={(nextOffset: number) => setVisibleKey(nextOffset)}
          >
            {collection.documents.map((document, index) => (
              <div key={`${document.id}-${index}`} className="overflow-grid-item">
                <div className="overflow-grid-content">
                  <ProductCard
                    item={document}
                    forwardedRef={overflowGridRef}
                    visibleKey={visibleKey}
                  />
                </div>
              </div>
            ))}
          </OverflowGrid>
        </VStack>
      </Container>
    </PageSection>
  );
};

export default ItemCollection;
